/**
 * Authentication Store Module
 * Handles user authentication state and actions
 */
import router from '@/router.js';

const state = {
  authToken: localStorage.getItem('authToken') || null,
  userId: localStorage.getItem('userId') || null,
  sessionId: null
};

const mutations = {
  SET_AUTH_TOKEN(state, token) {
    state.authToken = token;
    localStorage.setItem('authToken', token);
  },
  
  SET_USER_ID(state, userId) {
    state.userId = userId;
    localStorage.setItem('userId', userId);
  },
  
  SET_SESSION_ID(state, sessionId) {
    state.sessionId = sessionId;
  },
  
  CLEAR_AUTH_DATA(state) {
    state.authToken = null;
    state.userId = null;
    state.sessionId = null;
    
    localStorage.removeItem('authToken');
    localStorage.removeItem('userId');
  }
};

const actions = {
  /**
   * Generate a new session ID
   */
  generateSessionId({ commit }) {
    const sessionId = `sess-${new Date().getTime()}-${Math.random().toString(36).substr(2, 9)}`;
    commit('SET_SESSION_ID', sessionId);
  },
  
  /**
   * Log out the user and clear all authentication data
   */
  logout({ commit, dispatch }) {
    commit('CLEAR_AUTH_DATA');
    dispatch('customer/clearCustomerData', null, { root: true });
    
    router.push('/').catch(err => {
      console.error('Failed redirect to home:', err);
    });
  }
};

const getters = {
  /**
   * Check if the user is authenticated
   */
  isAuthenticated: state => !!state.authToken,
  
  /**
   * Get the auth token
   */
  authToken: state => state.authToken,
  
  /**
   * Get the user ID
   */
  userId: state => state.userId,
  
  /**
   * Get the session ID
   */
  sessionId: state => state.sessionId
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}; 